import { Component, Input } from '@angular/core';
import { ECVideoService } from '../../shared/ec-modal/ec-video.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { PracticeSectionContent } from '../practice-section/practice-section.interface';
import { ProfileLiteExtService } from '../../shared/profile-lite-ext.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject, combineLatest } from 'rxjs';

@Component({
  selector: 'lp2-videos-carousel',
  templateUrl: './videos-carousel.component.html',
  styleUrls: ['./videos-carousel.component.scss'],
})
export class VideosCarouselComponent extends ImmersionCarouselComponent implements PracticeSectionContent {
  @Input()
  title: string;

  @Input()
  protected includedTopics: string[];

  @Input()
  protected excludedTopics: string[];

  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.videosPoints = value
    ? value.get(GamificationActivityType.COMPLETE_PRACTICE_VIDEO)
    : 0;
  }

  showVideosCarousel$ = this.profileService.getPersonData$().pipe(map((personData) => personData.program.ecEnabled));
  private ecReady$ = new BehaviorSubject<boolean>(false);
  shouldDisplay$ = combineLatest([
    this.showVideosCarousel$,
    this.itemsLoaded$,
    this.ecReady$
  ]).pipe(map((statuses) => {
    return statuses.every(Boolean) && (this.immersionItems.length > 0 || this.ECError || this.hasError)
  }));

  ECLoaded: boolean;
  ECError: boolean;

  videosPoints: number;

  loading = false;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  public englishCentralEnabled: boolean = false;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService,
    private videoService: ECVideoService,
    private configurationService: ProfileServiceConfigurationService,
    private profileService: ProfileLiteExtService,
  ) {
    super(service, levelProgressService, CourseContentType.VIDEOS);
    videoService.initialize(
      () => {
        this.ECLoaded = true;
        this.ECError = false;
        this.ecReady$.next(true);
      },
      () => {
        this.ECError = true;
        this.ECLoaded = false;
        this.ecReady$.next(true);
      }
    );


    this.configurationService.englishCentralEnabled$().subscribe((enabled) => {
      this.englishCentralEnabled = enabled;
    });

    this.subscription.add(
      this.videoService.loading.subscribe((loading) => {
        this.loading = loading;
      })
    );

    this.subscription.add(
      this.videoService.onClose.subscribe((id: number) => {
        this.reloadCourseTileById(id);
      })
    );
  }

  viewVideo(video: StudyBundleCourseDto) {
    if (this.loading) {
      return;
    }
    this.videoService.open(video);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/videos-carousel/videos-carousel.component.ts